import Wrapper from "../../../layout/Wrapper";
import DiscountManageComponent from "../../../screens/settings/discounts/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Discount Management",
	description: "",
};

export default function DiscountMange() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<DiscountManageComponent />
		</Wrapper>
	);
}